// localStorage keys - same keys as Angular app
export const LS = {
  brand: 'brand',
  customerGroup: 'customerGroup',
  division: 'division',
  section: 'section',
  department: 'department',
} as const;

// localStorage keys for save recovery (matches Angular pattern)
export const UNSAVED_CELLS_KEY = 'UnsavedCellKeys';
export const SAVING_IN_PROGRESS_KEY = 'SavingInProgressCellKeys';

// Force-relogin session expiry (see docs/FORCE_RELOGIN_24H_PLAN.md)
export const LAST_LOGIN_TIMESTAMP_KEY = 'lastLoginTimestamp';
export const SESSION_MAX_AGE_MS = 24 * 60 * 60 * 1000;
export const COOKIE_CLEAR_PREFIXES = ['msal.'];

// localStorage keys for the cached timeline/calendar config (see gridDataService.ts)
export const TIMELINE_CONFIG_DATA_KEY = 'timelineConfigData';
export const TIMELINE_CONFIG_TIMESTAMP_KEY = 'timelineConfigTimestamp';

// Re-export localStorage helper functions from centralized module
// (Kept here for backward compatibility with existing imports)
export { lsGet, lsGetLabel, lsSet, lsSetLabel, lsClear } from '../utils/localStorageHelpers';
